// extracted by mini-css-extract-plugin
module.exports = {"zoom":"ZoomMenu_zoom__2_yIq","open":"ZoomMenu_open__ELKYD","line":"ZoomMenu_line__23NUl"};